import { icons, COLOR_GREEN, COLOR_ORANGE } from '@theme';
import { Tooltip } from '@mui/material';
import { IconOverlay } from '.';
import { carrierNameCapitalized, nonCarrierNameCapitalized } from '../../env';

type TenantIconProps = {
    isCarrier: boolean,
    activeSubscription: boolean,
    subscriptionEndDate: string | null,
    badgeSize: number,
    top: number,
    right: number,
    carrierSx?: object,
    nonCarrierSx?: object
};

const TenantIcon = (
    {
        isCarrier,
        activeSubscription,
        subscriptionEndDate,
        badgeSize,
        top,
        right,
        carrierSx,
        nonCarrierSx
    }: TenantIconProps
) => {
    const hasActiveSubscription = isCarrier && activeSubscription;
    const hasExpiredSubscription = isCarrier && !activeSubscription && subscriptionEndDate !== null;
    const shouldRenderBadge = hasActiveSubscription || hasExpiredSubscription;
    const name = isCarrier ? carrierNameCapitalized : nonCarrierNameCapitalized;
    // eslint-disable-next-line no-nested-ternary
    const tooltipText = `${name} ${hasActiveSubscription
        ? 'med aktivt abonnemang'
        : hasExpiredSubscription
            ? 'med utlöpt abonnemang'
            : ''}`;
    const iconOverlayProps = {
        shouldRenderBadge,
        symbol: 'A',
        badgeColor: hasActiveSubscription ? COLOR_GREEN : COLOR_ORANGE,
        badgeSize,
        top,
        right
    };

    return (
        <IconOverlay {...iconOverlayProps}>
            <Tooltip title={tooltipText}>
                {isCarrier
                    ? <icons.carrier color="primary" sx={carrierSx} />
                    : <icons.buyer color="primary" sx={nonCarrierSx} />}
            </Tooltip>
        </IconOverlay>
    );
};

export default TenantIcon;
